import axios from '@/api';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    fields: [],
    newFields: [],
  },
  getters: {
    payloadUserCustomFields: state => state.fields.map(f => ({ id: f.id, value: f.value }))
  },
  mutations: {
    SET_CUSTOM_FIELDS (state, payload) {
      let customFields = payload.map(f => ({ ...f, value: '' }));
      state.fields = customFields;
    },
    ADD_NEW_FIELD (state, field) {
      state.newFields.push(field);
    },
    REMOVE_NEW_FIELD (state, indexToRemove) {
      state.newFields.splice(indexToRemove, 1);
    },
    UPDATE_NEW_FIELD_INFO (state, { index, field }) {
      state.newFields[index] = field;
    },
    CLEAR_NEW_FIELDS (state) {
      state.newFields = [];
    },
    UPDATE_CONFIGURED_FIELD (state, { index, field }) {
      state.fields[index] = field;
    },
    UPDATE_USER_FIELD (state, field) {
      let index = state.fields.findIndex(f => f.id === field.id);
      // https://gist.github.com/DawidMyslak/2b046cca5959427e8fb5c1da45ef7748
      Vue.set(state.fields[index], 'value', field.value);
    },
    CLEAR_USER_CUSTOM_FIELDS_VALUES (state) {
      state.fields = state.fields.map(f => ({ ...f, value: ''}));
    }
  },
  actions: {
    getCustomFields ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/admin/partner/custom-fields/')
          .then(response => {
            commit('SET_CUSTOM_FIELDS', response.data);
            resolve(response.data);
          })
          .catch(error => reject(error.response));
      });
    },
    postCustomFields ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post(
          'admin/partner/custom-fields/',
          payload,
        ).then(response => {
          resolve(response.data);
        }).catch(error => {
          reject({ code: 500 })
          console.log('Error sendind custom fields request ', error);
        })
      });
    },
    addNewField ({ commit }) {
      let field = {
        label: '',
        type: '',
        required: true,
        isNew: true
      };
      commit('ADD_NEW_FIELD', field);
    },
    removeField ({ commit }, index) {
      commit('REMOVE_NEW_FIELD', index);
    },
    updateNewFieldInfo ({ commit }, params) {
      commit('UPDATE_NEW_FIELD_INFO', params);
    },
    clearNewFields ({ commit }) {
      commit('CLEAR_NEW_FIELDS');
    },
    updateConfiguredField ({ commit }, params) {
      commit('UPDATE_CONFIGURED_FIELD', params);
    },
    batchUploadTemplate () {
      return new Promise((resolve, reject) => {
        axios.get('/admin/partners/import/massive/template/')
          .then(response => {
            if (response.status === 200)
              resolve(response.data);
            else
              throw new Error('Error downloading template');
          })
          .catch(error => reject(error));
      });
    }
  }
};
